var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.4,67.87c0-10-4.1-18.44-26.32-23.73-13.4-3.17-17.57-5.87-17.57-12.7s5.08-10.86,14.03-10.86c11.07,0,15.07,5.49,16.35,11.9h11.69c-.87-8.46-6.3-17.14-18.76-19.92V0h-14.54v12c-13.76,1.79-20.68,10.19-20.68,20.58s6.14,17.1,24.96,21.57c15.13,3.58,18.94,7.58,18.94,14.97,0,6.91-4.61,12.11-16.12,12.11-10.82,0-17.04-4.65-19.08-13.54h-11.69c1.47,10.75,8.52,20.06,23.68,22.06v10.25h14.54v-10.54c13.74-2.39,20.58-10.91,20.58-21.59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignIcon);
export default __webpack_public_path__ + "static/media/DollarSignIcon.991c2cdc27aaab1fe981843f99e01b9d.svg";
export { ForwardRef as ReactComponent };